var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EFF6F2",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8h20v20H8z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#2F665C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.199 15.196h-1.136L21.093 10l-1.388.794 2.516 4.402h-8.443l2.517-4.402-1.39-.794-2.97 5.196H10.8a.8.8 0 0 0-.772 1.01l2.239 8.211a1.604 1.604 0 0 0 1.544 1.179h8.378c.718 0 1.353-.484 1.544-1.18l2.239-8.21a.798.798 0 0 0-.773-1.01zm-3.011 8.8v.8-.8H13.81l-1.963-7.2H24.15l-1.963 7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6 18.396h1.6v4h-1.6v-4zm3.2 0h1.6v4h-1.6v-4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSold);
export default __webpack_public_path__ + "static/media/ic-sold.12110521ed9afa321bc593cfe1998da9.svg";
export { ForwardRef as ReactComponent };